import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a number using Swedish locale without grouping separators.
 * Usage: {{ value | svNumber }}
 */
@Pipe({
  name: 'svNumber',
  standalone: false,
})
export class SwedishNumberPipe implements PipeTransform {
  transform(value: number | null | undefined, decimals?: number): string {
    if (value === null || value === undefined) {
      return '';
    }

    // Default to maximum 2 fraction digits if not specified
    const maxDecimals = decimals !== undefined ? decimals : 2;

    let formatted = value.toLocaleString('sv-SE', {
      useGrouping: false,
      maximumFractionDigits: maxDecimals,
    });

    // Replace Swedish minus sign with standard hyphen
    formatted = formatted.replace(/\u2212/g, '-');

    // Handle negative zero (e.g., "-0" or "-0,00")
    // If the string starts with - and consists only of 0s and punctuation, strip the minus
    // Regex: ^-0([.,]0+)?$ matches -0, -0.00, -0,000 etc.
    if (/^-0([.,]0+)?$/.test(formatted)) {
      formatted = formatted.substring(1);
    }

    return formatted;
  }
}
